import * as React from 'react';
import { Text } from 'office-ui-fabric-react';
import { jsx as _jsx } from "react/jsx-runtime";
export let SubHeadingLevel = /*#__PURE__*/function (SubHeadingLevel) {
  SubHeadingLevel[SubHeadingLevel["Level1"] = 0] = "Level1";
  SubHeadingLevel[SubHeadingLevel["Level2"] = 1] = "Level2";
  SubHeadingLevel[SubHeadingLevel["Level3"] = 2] = "Level3";
  SubHeadingLevel[SubHeadingLevel["Level4"] = 3] = "Level4";
  return SubHeadingLevel;
}({});
export const SubHeading = props => {
  switch (props.headingLevel) {
    case SubHeadingLevel.Level1:
      return /*#__PURE__*/_jsx(Text, {
        variant: "xLarge",
        children: props.children
      });
    case SubHeadingLevel.Level2:
      return /*#__PURE__*/_jsx(Text, {
        variant: "mediumPlus",
        children: props.children
      });
    case SubHeadingLevel.Level3:
      return /*#__PURE__*/_jsx(Text, {
        variant: "medium",
        children: props.children
      });
    case SubHeadingLevel.Level4:
      return /*#__PURE__*/_jsx(Text, {
        variant: "smallPlus",
        children: props.children
      });
  }
  return /*#__PURE__*/_jsx(Text, {
    children: props.children
  });
};